import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtP, SEG_LABEL } from "@/lib/jackpot";

const CHIP = { plus: "bg-pink-500/20 text-pink-200", minus: "bg-white/10 text-white/70", double: "bg-amber-300/20 text-amber-200", halve: "bg-slate-200 text-slate-900 ring-1 ring-white/60", bankrupt: "bg-red-500/25 text-red-300" };

export function JackpotActivity({ live, tick }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const load = () => api.get("/jackpot/activity").then(({ data }) => setRows(data)).catch(() => {});
    load();
    if (!live) return undefined;
    const i = setInterval(load, 4000);
    return () => clearInterval(i);
  }, [live, tick]);
  return (
    <section className="rounded-[1.75rem] jr-panel p-5 sm:p-6" data-testid="jr-activity">
      <div className="flex items-center justify-between">
        <h2 className="font-display text-lg font-extrabold text-white">Live am Rad</h2>
        {live && <span className="inline-flex items-center gap-1.5 text-[11px] font-bold text-pink-200"><span className="w-2 h-2 rounded-full bg-pink-400 jr-live-dot" /> live</span>}
      </div>
      {!rows ? <p className="mt-3 text-sm text-white/50">Lädt …</p> : rows.length === 0 ? <p className="mt-3 text-sm text-white/50" data-testid="jr-activity-empty">Noch niemand hat gedreht – sei die/der Erste!</p> : (
        <ul className="mt-3 space-y-1.5 max-h-80 overflow-y-auto pr-1">
          {rows.map((r) => (
            <li key={r.id} className="flex items-center gap-2 text-sm jr-row-in" data-testid={`jr-activity-${r.seq}`}>
              <span className="w-8 text-[11px] font-bold text-white/40 tabular-nums">#{r.seq}</span>
              <span className="flex-1 min-w-0 truncate text-white/85">{r.mine ? "Du" : r.name || "Ein Mitglied"}</span>
              <span className={`px-2 h-6 inline-flex items-center rounded-full text-[11px] font-extrabold ${CHIP[r.result]}`}>{SEG_LABEL[r.result]}</span>
              <span className="w-20 text-right text-xs font-bold text-amber-200 tabular-nums">{fmtP(r.after)}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
